/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  TransferAvailableBalancesOptions,
  TransferAvailableBalancesResponses,
} from '../types/TransferAvailableBalances'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Transfer available balance between a user's accounts (e.g. global to isolated position)
 * {@link /v1/positions/transfer_balances}
 */
export function transferAvailableBalances<ThrowOnError extends boolean = true>(
  options: Options<TransferAvailableBalancesOptions, ThrowOnError>,
): Unwrappable<RequestResult<TransferAvailableBalancesResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/positions/transfer_balances',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<TransferAvailableBalancesResponses, ThrowOnError>>,
  )
}
